// IMAGES
import fullStar from "../../assets/full-star.png";
import halfStar from "../../assets/half-star.png";
import emptyStar from "../../assets/empty-star.png";

export default function Rating() {
  return (
    <div className="flex items-center space-x-2">
      <div>
        <img src={fullStar} alt="" className="w-4 h-4" />
      </div>
      <div>
        <img src={fullStar} alt="" className="w-4 h-4" />
      </div>
      <div>
        <img src={fullStar} alt="" className="w-4 h-4" />
      </div>
      <div>
        <img src={halfStar} alt="" className="w-4 h-4" />
      </div>
      <div>
        <img src={emptyStar} alt="" className="w-4 h-4" />
      </div>
    </div>
  );
}
